var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({staticClass:"cursor-pointer w-1/2 border border-solid border-grey",attrs:{"type":"range","min":_vm.min,"step":_vm.step,"max":_vm.max}},_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }